export enum StartNumberStateEnum {
    PURCHASED = 'P',
    RESERVED = 'R'
}